var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeMoreArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56247 3.96874L4.65164 2.05791C4.5344 1.94072 4.3754 1.8749 4.20962 1.87494C4.04385 1.87498 3.88488 1.94087 3.76769 2.05812C3.65049 2.17536 3.58468 2.33436 3.58472 2.50014C3.58476 2.66591 3.65065 2.82488 3.76789 2.94208L5.67872 4.85249C5.69813 4.87184 5.71352 4.89483 5.72402 4.92015C5.73452 4.94546 5.73993 4.97259 5.73993 4.99999C5.73993 5.0274 5.73452 5.05453 5.72402 5.07984C5.71352 5.10515 5.69813 5.12814 5.67872 5.14749L3.76789 7.05791C3.65065 7.1751 3.58476 7.33407 3.58472 7.49985C3.58468 7.66562 3.65049 7.82462 3.76769 7.94187C3.88488 8.05911 4.04385 8.12501 4.20962 8.12505C4.3754 8.12508 4.5344 8.05927 4.65164 7.94208L6.56247 6.03124C6.83549 5.75748 6.9888 5.38662 6.9888 4.99999C6.9888 4.61336 6.83549 4.24251 6.56247 3.96874Z",
    fill: "#868E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMoreArrow);
export default __webpack_public_path__ + "static/media/SeeMoreArrow.8e08cf437b92b2a3ac3fee2f9ed163e1.svg";
export { ForwardRef as ReactComponent };